module.exports = __webpack_public_path__ + "img/growcify-logistics-partner.e5116f36.png";